import React from 'react'

const IconRightLines = () => {
  return (
    <svg width="95" height="131" viewBox="0 0 95 131" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.765129 1C43.2651 27.5 68.7651 69.5 73.7651 130.5" stroke="#CEDEF2" stroke-width="1.6" />
      <path d="M87.3667 104C80.2726 61.4606 61.9168 29.3433 33.7654 6.18164" stroke="#CEDEF2" stroke-width="1.6" />
      <path d="M61.6576 17.5C76.4463 34.3153 87.3437 54.6986 94 79" stroke="#CEDEF2" />
    </svg>
  )
}

export default IconRightLines
